export default "__VITE_PUBLIC_ASSET__0553698e__"